import React from "react";

import SubcategoryList from "./SubcategoryList";
import SubcategoryBreadcrumb from "./SubcategoryBreadcrumb";

import Attachments from "./Attachments";
import BreadCrumb from "./SubcategoryBreadcrumb";

class Subcategory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      category: props.category,
      listMode: true,
      breadCrumbArr: [],
    };
    this.onUpdateSubcategory = this.onUpdateSubcategory.bind(this);
    this.onRemoveBreadCrumb = this.onRemoveBreadCrumb.bind(this);
  }

  onUpdateSubcategory(subcategory) {
    this.state.breadCrumbArr.push(subcategory);
    let tempArr = this.state.breadCrumbArr;
    localStorage.setItem("breadCrumb", JSON.stringify(tempArr));
    this.setState({ category: subcategory }, () => {
      console.log("BreadCrumb", this.state.breadCrumbArr);
    });
  }

  onRemoveBreadCrumb(data, index) {
    var tempArr = [];
    var breadCrumb = [];
    for (let i = 0; i <= index; i++) {
      tempArr.push(this.state.breadCrumbArr[i]);
      breadCrumb.push(this.state.breadCrumbArr[i]);
    }
    localStorage.setItem("breadCrumb", JSON.stringify(breadCrumb));
    this.setState({ category: data, breadCrumbArr: tempArr });
  }

  componentDidMount() {
    this.state.breadCrumbArr.push(this.props.category);
    this.setState({ breadCrumbArr: this.state.breadCrumbArr }, () => {
      // localStorage.setItem(
      //   "breadCrumb",
      //   JSON.stringify(this.state.breadCrumbArr)
      // );
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.category !== this.props.category) {
      this.setState({ category: this.props.category });
    }
  }
  getBreadCrumbData = () => {
    console.log("bread crumb", localStorage.getItem("breadCrumb"));
    let arr = localStorage.getItem("breadCrumb");
    if (arr != "") {
      arr = JSON.parse(arr);
      return arr;
    }
    return {};
  };
  render() {
    const { selectedRecord, breadCrumbArr } = this.state;
    let category = {};
    let breadCrumb = [];

    if (breadCrumbArr.length) {
      breadCrumb = this.getBreadCrumbData();
      category = breadCrumb[breadCrumb.length - 1];
      console.log(breadCrumb, category);
    }

    return (
      <div className="container-fluid">
        {breadCrumbArr.length ? (
          <>
            <SubcategoryBreadcrumb
              data={breadCrumb}
              onRemoveBreadCrumb={this.onRemoveBreadCrumb}
            />
            <SubcategoryList
              category={category}
              breadCrumbArr={breadCrumbArr}
              onUpdateSubcategory={this.onUpdateSubcategory}
            />
            <Attachments category={category} />
          </>
        ) : null}
      </div>
    );
  }
}

export default Subcategory;
